import { FilmStripIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Videos = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <FilmStripIcon {...rest} size={Sizes[size]} color={fill} />;
};

Videos.displayName = 'Videos';
